import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

// Floating Contact Dropdown Functionality
$(function () {
    const $dropdownContainer = $('.floating-contact-dropdown');
    if ($dropdownContainer.length) {
        const $btn = $dropdownContainer.find('#contactDropdownButton');

        $btn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $dropdownContainer.toggleClass('is-open');
            $btn.attr('aria-expanded', $dropdownContainer.hasClass('is-open'));
        });

        $(document).on('click', function (e) {
            if (!$dropdownContainer.is(e.target) && $dropdownContainer.has(e.target).length === 0) {
                $dropdownContainer.removeClass('is-open');
                $btn.attr('aria-expanded', 'false');
            }
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                $dropdownContainer.removeClass('is-open');
                $btn.attr('aria-expanded', 'false');
            }
        });
    }
});

/**
 * Minimizes the padding of an element in dependency of the scroll position.
 * Typically used for sticky header navs.
 */
$('.scroll-minimizer').each(function () {
    const minimum = 0.3;
    const paddingTop = parseInt($(this).css('padding-top'));
    const paddingBottom = parseInt($(this).css('padding-bottom'));
    const paddingTotal = paddingTop + paddingBottom;
    if (!paddingTotal) return;
    const $minimizerObj = $(this);

    const scrollFunction = function () {
        const scrollRelative = 1 - Math.min($(window).scrollTop() / paddingTotal, 1 - minimum);
        const top = paddingTop * scrollRelative;
        const bottom = paddingBottom * scrollRelative;

        $minimizerObj.css({
            'padding-top': top + 'px',
            'padding-bottom': bottom + 'px',
        });
    };

    $(window).scroll(scrollFunction);
    scrollFunction();
});

/**
 * Scrolls down below the element (self) on click
 */
$('.scroll-down-self').each(function () {
    if (inBackend) return;

    $(this).css('cursor', 'pointer');
    $(this).on('click', function (event) {
        event.preventDefault();

        let offset = 50;
        const dataOffset = $(this).data('scroll-down-offset');
        if (dataOffset !== undefined) {
            offset = parseFloat(dataOffset);
        }

        $('html, body').animate({
            scrollTop: $(this).position().top + $(this).outerHeight(true) - offset,
        }, 450);
    });
});

/**
 * Open external links in new window
 */
$("a").filter('[href^="http"], [href^="https"], [href^="//"]')
    .not('[href*="' + window.location.host + '"]')
    .attr('rel', 'noopener noreferrer')
    .attr('target', '_blank')
    .addClass("external-link");
